import { withTranslation } from "react-i18next";
import VinWonderInfo from './VinWonderInfo';

export default withTranslation()(VinWonderInfo);